import { Box } from '@medely/ui-kit';
import { Dialog, DialogProps } from '@medely/web-components';
import React from 'react';
import { RecommendedSpecialtiesModal, useRecommendedSpecialtiesData } from '..';
import { OFFER_SOURCE } from '../../../constants/analytics';
import { IPreBookConfirmationProps } from './interface';
import { useCurrentUser } from '@mp/hooks';
import { parseFragmentData } from '@mp/graphql/generated';
import { JobDetailsFragment } from '../jobDetailsComponents/graphql';
import { JobPositionsProps } from '@mp/utils';
import useDialog from '@mp/hooks/useDialog';
import { PreBookConfirmationInfo } from './PreBookConfirmationInfo';
import { PreBookConfirmationButtons } from './PreBookConfirmationButtons';

type IPreBookConfirmationDialogProps = DialogProps & IPreBookConfirmationProps;

export const PreBookConfirmationDialog = ({
  open,
  onClose = () => null,
  job: inputJob,
  bookJob,
  bookingLoading,
  bookJobWithAttestation,
  bookAndAttestLoading,
  userCoordinates,
  onboarding = false,
  disabled = false,
}: IPreBookConfirmationDialogProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);
  const recommendedSpecialtiesModal = useDialog();
  const { currentUser } = useCurrentUser();

  const { userHasAllRequiredSpecialties, specialtyOptions } = useRecommendedSpecialtiesData({
    jobPositions: job?.positions as JobPositionsProps[],
    jobSpecialties: job?.specialties,
    jobMissingHighRiskSpecialties: job?.missing_high_risk_specialties,
    userSpecialties: currentUser?.professional?.specialties,
  });

  const bookJobAction = () => {
    return bookJob(job?.id, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  const handleBookButtonAction = () => {
    if (!userHasAllRequiredSpecialties && specialtyOptions?.length) {
      return recommendedSpecialtiesModal.openDialog();
    }
    onboarding
      ? bookJobWithAttestation(
          { jobId: job?.id as number, attest: true, offer_source: OFFER_SOURCE.o },
          {
            onSuccess: () => {
              onClose();
            },
          },
        )
      : bookJobAction();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        title="Review shift details"
        data-testid="book-job-confirmation-dialog"
        maxWidth="sm"
        fullWidth
        content={
          <Box pb={1}>
            <PreBookConfirmationInfo userCoordinates={userCoordinates} job={inputJob} />
          </Box>
        }
        actions={
          <PreBookConfirmationButtons
            closeButtonClick={onClose}
            disabled={bookingLoading || bookAndAttestLoading || disabled}
            loading={bookingLoading || bookAndAttestLoading}
            handleBookClick={handleBookButtonAction}
          />
        }
      />
      <RecommendedSpecialtiesModal
        open={recommendedSpecialtiesModal.open}
        onClose={() => recommendedSpecialtiesModal.closeDialog()}
        options={specialtyOptions}
        handleContinueClick={() => bookJobAction()}
      />
    </>
  );
};
